<div class="row">
  <div class="col-6">
    <strong>&copy; {{settings.getAppSetting('year')}}</strong> - {{ settings.getAppSetting('name') }} [v.{{version}}]
  </div>
  <div class="col-6">
    <div class="text-right">
      <em>{{settings.getAppSetting('description')}}</em>
    </div>
  </div>
</div>
